import { useTranslation } from "react-i18next";
import FullPageError from "../../portal/FullPageError";

const NotFound = () => {
    const { t } = useTranslation();
    return <FullPageError statusCode={"404"} header={t("errors.notFound")} />;
};

export default NotFound;
